import { Link } from "react-router-dom";
export class CreditListPage extends Component {
  constructor(props) {
    super(props);
    props.initialconstruct.bind(this)("CreditListPage");
    this.state = {
      rowcount: 0,
      tableData: [],
      columns: [
        {
          title: "Application ID",
          dataIndex: "application_id",
          hasFilter: true,
          render: (text, record) => <Link to={`/app/credit_list/credit_info?application_id=${text}`}>
            Application ID #{text}
          </Link>,
        },
        {
          title: "Bill Type",
          dataIndex: "bill_type",
          hasFilter: true,
        },
        {
          title: "Fund Required",
          dataIndex: "fund_required",
          hasFilter: true,
        },
        {
          title: "Updated On",
          dataIndex: "last_updated_on",
          render: (text, record) => (text || "").date().moment().format("DD MMM YYYY"),
          hasFilter: true,
        },
        {
          title: "User ID",
          dataIndex: "user_id",
          hasFilter: true,
        }
      ],
    };
  }

  onPageChange() {}

  editAction() {}

  deleteAction() {}

  fetchData(data={}) {
    this.api.apiGetRequirement(data).then((response) => {
      let result = response.data.items;
      this.setState({
        rowcount: result.length,
        tableData: result
      });
    });
  }

  onSearch() {
    this.fetchData();
  }

  componentDidMount() {
    this.fetchData();
  }


  editCreditInfo() {
    let url = "/app/credit_list/credit_info";
    navigate(url);
  }

  render() {
    let { editCreditInfo } = this;
    const breadCumRight = () => (
      <div className="col-auto float-end ml-auto">
        <a className="btn add-btn text-white" onClick={() => editCreditInfo()}>
          <i className="fa fa-plus" /> Request Credit
        </a>
      </div>
    );
    let { tableData, columns, rowcount, links } = this.state;
    return (
      <AppWrapper title="Credit Info" slots={{ breadCumRight }}>
        <div className="row mb-4">
          <div className="col">
            <AppTable
              data={tableData}
              columns={columns}
              reorder={true}
              onChange={(...arg) => this.onPageChange(...arg)}
              total={rowcount}
              editAction={(data) => this.editAction(data)}
              deleteAction={(data) => this.deleteAction(data)}
              pageSize={10}
            ></AppTable>
          </div>
        </div>
      </AppWrapper>
    );
  }
}

export default connect(CreditListPage);
